module.exports = __webpack_public_path__ + "img/banner-luna-mobile.0dbc1186.png";